<template>
  <el-popover placement="right" width="250" trigger="hover" :offset="80">
    <div class="text-medium mr-b4">
      신호세기 (RSSI)
    </div>
    <ul class="dot-list">
      <li v-for="item in rssiInfo" :key="item.id">
        <i :class="item.classInfo"></i>{{item.text}}
      </li>
    </ul>
    <span slot="reference"><i class="info-text fas fa-info-circle c-pointer"></i></span>
  </el-popover>
</template>

<script>
export default {
  name: 'WSignalStrengthLegend',
  data() {
    return {
      rssiInfo: [
        {
          classInfo: 'mr-r10 wireless-signal-icon strength-4',
          id: 4,
          text: '(매우 강함) : RSSI > -50',
        },
        {
          classInfo: 'mr-r10 wireless-signal-icon strength-3',
          id: 3,
          text: '(강함) : RSSI > -60',
        },
        {
          classInfo: 'mr-r10 wireless-signal-icon strength-2',
          id: 2,
          text: '(약함) : RSSI > -70',
        },
        {
          classInfo: 'mr-r10 wireless-signal-icon strength-1',
          id: 1,
          text: '(매우 약함) : RSSI < -70',
        },
      ],
    };
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/wireless-ap/components/SignalStrengthLegend.vue